// extracted by mini-css-extract-plugin
module.exports = {"tertiaryButton":"button_tertiaryButton__1Vlut"};